module.exports = __webpack_public_path__ + "static/media/moyenstanding2.186d266b.jpg";